import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import useAtivoPatrimonial, { ATIVO_MODAL_NAME, LOAD_MESSAGE } from './AtivoPatrimonialHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import AtivoPatrimonialModal from './AtivoPatrimonialModal'

function AtivoPatrimonial({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useAtivoPatrimonial()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.INITIAL_FECTH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.onInitFetch()
        break
      case LOAD_MESSAGE.FETCH_ATIVOS:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.getAtivosByOwner(state.selectedOwner.patrimonio_owner_id)
        break
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  // Render
  return (
    <>
      <PageHeader>6.1 - Ativo Patrimônial</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onNovoClick(state.selectedOwner)}
          onVoltar={() => history.goBack()}
        >
          <div className="p-col-4" style={{ marginBottom: '20px' }}>
            <CustomDropdown
              optionLabel="patrimonio_owner_name"
              options={state.owners}
              value={state.selectedOwner}
              label="Dono do Patrimonio :*"
              filter={true}
              onChange={value => localDispatch.onSelectedOwnerChange(value)}
            />
          </div>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                value={state.ativos}
                emptyMessage={'Não existe nenhum Ativo cadastrado'}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
              >
                <Column field={'id'} header={'Código'} style={tableCellCentered()} />
                <Column field={'num_ativo'} header={'Número'} style={tableCellCentered(150)} />
                <Column field={'name'} header={'Patrimônio'} />
                <Column
                  header={'#'}
                  body={item => (
                    <ThreeDots
                      items={['Editar']}
                      onClick={menuItem => localDispatch.onMenuItemClick(menuItem, item)}
                    />
                  )}
                  style={tableCellCentered(80)}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <AtivoPatrimonialModal
        tpId={selectedTp}
        ativoPatrimonial={state.selectedAtivo}
        selectedOwner={state.selectedOwner}
        visible={state.showModal === ATIVO_MODAL_NAME.CADASTRO}
        onResponse={localDispatch.onCadastroModalResponse}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AtivoPatrimonial))
